import { colors } from '@insurancemenu/imenu-components-lib';
import { boxShadows } from '@insurancemenu/imenu-components-lib/dist/utils';
import { createUseStyles } from 'react-jss';
import { ComponentStylesProps } from '@insurancemenu/imenu-components-lib/dist/types';

const styles: ComponentStylesProps<boolean> = {
  actionButton: {
    textTransform: 'uppercase',
    padding: 0,
    fontWeight: 700,
  },
  card: (isChecked) => ({
    position: 'relative',
    padding: '2.5rem 2.5rem 2rem',
    backgroundColor: colors.neutral.white,
    border: `1px solid ${colors.blue[600]}`,
    borderRadius: '1rem',
    boxShadow: boxShadows.light[4],
    '&::before': {
      content: "''",
      display: isChecked ? 'block' : 'none',
      position: 'absolute',
      top: 0,
      bottom: 0,
      left: 0,
      width: '1rem',
      borderRadius: '1rem 0 0 1rem',
      backgroundColor: colors.blue[600],
    },
  }),
  emailInfo: {
    display: 'flex',
    justifyContent: 'space-between',
    paddingBottom: '1.5rem',
    marginBottom: '1rem',
    borderBottom: `1px solid ${colors.blue[300]}`,
  },
  description: {
    fontSize: '1.6rem',
    lineHeight: '2.6rem',
  },
  checkboxWrapper: {
    '& svg': {
      fill: colors.blue[600],
      width: '2.5rem',
      height: '2.5rem',
      margin: 0,
    },
    '& span': {
      fontWeight: 700,
      fontSize: '1.8rem',
    },
  },
};

const createStyles = createUseStyles(styles);

export { createStyles };
